export const baseApiUrl = 'https://api.gobistories.com/api/v5/renders';

export interface GobiApiResponse {
    viewKey: string;
    version: number;
    title: string;
    videoUrl: string;
    streamingUrl: string;
    thumbnailUrl: string;
    posterUrl: string;
    coverUrl: string;
    chapters: {
        id: string;
        order: number;
        duration: number;
        stickers: {
            type: 'TEXT' | 'LINK' | 'DUMB';
            order: number;
            x: number;
            y: number;
            scale: number;
            rotation: number;
            imageUrl: string | null;
            linkUrl: string | null;
            text: string | null;
        }[];
    }[];
    animatedThumbnailUrl?: string;
    webmThumbnailUrl?: string;
    mp4ThumbnailUrl?: string;
    webmCoverUrl?: string;
    mp4CoverUrl?: string;
    whiteLabel?: boolean;
}

export type GobiApiResponseNarrowed = Pick<GobiApiResponse, 'title' | 'posterUrl' | 'whiteLabel'>;
